import {
  Category,
  Facility,
  IFormInputs,
  UserResponse,
  GetUserParams,
  User,
  AppointmentItem,
  UpdateAppointment
} from "../types/appointmentType";
import { appointmentApi, authApi } from "./axiosConfig";
import { apiCall } from "../helper/apiHelper";
import { addDays, format } from "date-fns";


export const getSpecializations = async (): Promise<Category[] | null> => {
  return apiCall({
    instance: appointmentApi,
    url: "/Lookup/GetSpecializations",
    method: "GET",
    config: {
      params: { onlyActive: true },
    },
  });
};

export const getFacilities = async (): Promise<Facility[] | null> => {
  return apiCall({
    instance: appointmentApi,
    url: "/Lookup/GetFacilities",
    method: "GET",
    config: {
      params: { onlyActive: true },
    },
  });
};

// Resolve a single active hospital by its booking slug (partner entry links).
export const getFacilityBySlug = async (
  slug: string
): Promise<{ item: Facility | null; successful: boolean } | null> => {
  return apiCall({
    instance: appointmentApi,
    url: `/Lookup/GetFacilityBySlug/${encodeURIComponent(slug)}`,
    method: "GET",
  });
};

// Resolve a single hospital by numeric id (fallback for /hospital/<id> links).
export const getFacilityById = async (
  id: number
): Promise<{ item: Facility | null; successful: boolean } | null> => {
  return apiCall({
    instance: appointmentApi,
    url: `/Lookup/GetFacilityById/${id}`,
    method: "GET",
  });
};

export const createAppointment = async (
  appointment: IFormInputs
): Promise<UserResponse | null> => {
  return apiCall({
    instance: appointmentApi,
    url: "/Appointment/CreateAppointment",
    method: "POST",
    data: appointment,
  });
};

export const getDoctors = async ({
  page = 1,
  count = 100000,
  status = 1,
  userCategoryId = 2,
  facilityId,
}: GetUserParams): Promise<User | null> => {
  return apiCall({
    instance: authApi,
    url: "/User/GetUsers",
    method: "GET",
    config: {
      params: { page, count, status, userCategoryId, facilityId },
    },
  });
};

export const getDoctorAvailability = async (
  userId: string,
  startDate?: Date,
  endDate?: Date
): Promise<UserResponse | null> => {
  const today = new Date();
  const dateFrom = format(startDate || today, "MM-dd-yyyy");
  const dateTo = format(endDate || addDays(today, 6), "MM-dd-yyyy 23:59:59");
  return apiCall({
    instance: appointmentApi,
    url: "/Appointment/GetDoctorAvailabilityByUserId",
    method: "POST",
    config: {
      params: {
        userId,
        dateFrom,
        dateTo,
      },
      data: {
        page: 0,
        count: 0,
        status: 0,
      },
    },
  });
};;


export const getUserSpecialization = async (
  userId: number
): Promise<UserResponse | null> => {
  return apiCall({
    instance: authApi,
    url: "/User/GetUserSpecializations",
    method: "GET",
    config: {
      params: {
        userId,
      },
    },
  });
};

export const getAppointmentById = async (id: number): Promise<UserResponse | null> => {
  return apiCall({
    instance: appointmentApi,
    url: `/Appointment/GetAppointmentById/${id}`,
    method: "GET",
  });
};
export const getAppointmentsByPhoneNumber = async (
  phoneNumber: string,
  page: number,
  count: number,
  status: number
): Promise<AppointmentItem[] | null> => {
  return apiCall({
    instance: appointmentApi,
    url: `/Appointment/GetAppointmentsByPhoneNumber`,
    method: "POST",
    config: {
      params: { phoneNumber },
      data: { page, count, status }
    },
  });
};

export const updateAppointment = async (
  appointment: UpdateAppointment
): Promise<UserResponse | null> => {
  const { id, ...appointmentData } = appointment;
  return apiCall({
    instance: appointmentApi,
    url: `/Appointment/UpdateAppointment/${id}`,
    method: "PUT",
    data: appointmentData,
  });
};

export const cancelAppointment = async (id: number): Promise<UserResponse | null> => {
  return apiCall({
    instance: appointmentApi,
    url: `/Appointment/CancelAppointment/${id}`,
    method: "DELETE",
  });
};

